import classNames from 'classnames';

export function PulsatingDot({ className, color = 'bg-green-500' }) {
  return <div className={classNames('w-1.5 h-1.5 rounded-full animate-pulse', color, className)} />;
}
